import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  open() {
    $(this.element).modal("show");

    // Focus the first element with the autofocus attribute when the modal is shown
    $(this.element).on('shown.bs.modal', function (e) {
      let modal = e.currentTarget;
      modal.querySelector('[autofocus]')?.focus();
    })
  }

  close(event) {
    event.preventDefault();
    $(this.element).modal("hide");
  }

  // Cleanup modal backdrop and body classes before the page is cached
  teardown() {
    $(this.element).modal("hide");
    document.querySelector(".modal-backdrop")?.remove();
    document.body.classList.remove("modal-open");
  }
}
